// Simple toast notification system for db errors
// Usage: import { showToast } from "../utils/toast";
//        showToast("Could not save student", "error");

let _toastCallback = null;

// Called by App.jsx to register the toast handler
export const registerToastHandler = (callback) => {
  _toastCallback = callback;
};

// Called by db.js and other utils to show a toast
export const showToast = (message, type = "error") => {
  if (_toastCallback) {
    _toastCallback({ message, type, id: Date.now() });
  }
};

// Friendly error messages based on operation type
export const dbError = (operation, entity, error) => {
  console.error(`${operation} ${entity}:`, error);

  // Don't toast on permission errors during initial load (RLS timing)
  if (error?.code === "42501" || error?.message?.includes("permission denied")) {
    return;
  }

  // Network errors
  if (error?.message?.includes("Failed to fetch") || error?.message?.includes("NetworkError") || error?.message?.includes("Load failed") || error?.name === "TypeError") {
    showToast("Connection lost. Please check your internet and try again.", "error");
    return;
  }

  // Duplicate/conflict errors
  if (error?.code === "23505" || error?.message?.includes("duplicate")) {
    showToast(`This ${entity} already exists.`, "error");
    return;
  }

  // Generic messages by operation type
  const messages = {
    fetch: `Could not load ${entity}. Pull to refresh or try again.`,
    save: `Could not save ${entity}. Please try again.`,
    delete: `Could not delete ${entity}. Please try again.`,
    sync: `Could not sync ${entity}. Changes may not be saved.`,
  };

  showToast(messages[operation] || `Something went wrong with ${entity}.`, "error");
};
